import Skeleton from "react-loading-skeleton";
import React from "react";
import 'react-loading-skeleton/dist/skeleton.css'

export const SkeletonLoading = () =>{

    return (
        <React.Fragment>
            {
                Array.from(Array(1), () =>(
                    <li>
                        <div className="project" >
                            <div className="list">
                                <div className="owner">
                                    <div className="flex-column">
                                        <Skeleton height={15} width={100}  />
                                        <Skeleton circle={true} height={50} width={50} />
                                        <Skeleton height={10} width={50} count={2} />
                                    </div>
                                </div>
                                <div className="detail">
                                    <div className="info" style={{ margin: '.5em 0' }}>
                                        <div className="flex">
                                            <div className="title mt-2"> <Skeleton height={10} width={300} /> </div>
                                        </div>
                                        <div className="stars" style={{ margin: 0 }} >
                                            <Skeleton height={25} width={25} circle className="mr-2" />
                                            <Skeleton height={25} width={25} circle className="mr-2" />
                                            <Skeleton height={25} width={25} circle className="mr-2" />
                                            <Skeleton height={25} width={25} circle className="mr-2" />
                                            <Skeleton height={25} width={25} circle className="mr-2" />
                                        </div>
                                        <ul>
                                            <li>
                                                <Skeleton count={3} width={350} height={10} />
                                            </li>
                                        </ul>
                                    </div>
                                
                                </div>
                            </div>
                            <div className="cover" style={{marginRight:'1em'}}>
                                <Skeleton width={100} height={100} />
                            </div>
                        </div>
                    </li>
                ))
            }
        </React.Fragment>
    )
}
